import { IconNoDataIcon } from 'src/icons';

export const EmptyDocumentsState = () => {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <div className="mb-6 flex items-center justify-center rounded-full bg-neutral-500">
        <IconNoDataIcon className="h-[104px] w-[104px]" />
      </div>
      <h3 className="mb-2 text-heading-lg-desktop text-neutral-black">
        All documents filtered out
      </h3>
      <p className="text-body-sm-desktop text-neutral-200">Please check your filtering criteria</p>
    </div>
  );
};
